import Time from './Time'
import './Message.scss'

const Message = ({ message }) => {
  return (
    <div className='banner'>
      <div className='banner-message'>{message}</div>
      <div className='time'>
        <Time />
      </div>
    </div>
  )
}

export default Message
